import $ from 'jquery';
import breakpoint from '../scripts/breakpoint';

$.addInit(function(context){
	var base = '.i-archive';
	$(base, context).each(function(){
		var component = $(this);
		var sidebar = component.find(base + '-sidebar');
		var sidebarHeigth = sidebar.outerHeight();
		var sidebarTop = sidebar.offset().top;
		var posts = component.find(base + '-section');
		var links = component.find(base + '-randstadNavItem');
		links.first().addClass('m-active');
		var delta = 140;

		function sidebarScroll() {
			var windowTop = $(window).scrollTop();

			posts.each(function(i) {
				if ($(this).position().top <= windowTop - sidebarTop - delta + sidebarHeigth) {
					links.removeClass('m-active');
					links.eq(i).addClass('m-active');
				}
			});
		};

		breakpoint('xs', 'lg')
			.onmatch(function(){
				$(window).off('scroll', sidebarScroll);
			})
			.onmismatch(function(){
				sidebarScroll();
				$(window).on('scroll', sidebarScroll);
			});
	});
});